import { ElementTypes } from '../element-types';

export class PromoCode {
  private static readonly prefix: string = 'promo-code';
  static readonly ApplyButton: string = `${PromoCode.prefix}-${ElementTypes.Button}-send`;
  static readonly CodeInput: string = `${PromoCode.prefix}-${ElementTypes.Input}-email`;
  static readonly Link: string = `${PromoCode.prefix}-${ElementTypes.Button}-link`;
  static readonly FailureMsg: string = `${PromoCode.prefix}-${ElementTypes.Div}-failure`;
  static readonly SuccessMsg: string = `${PromoCode.prefix}-${ElementTypes.Div}-success`;
}

export class DiscountTag {
  private static readonly prefix: string = 'price-tag';
  static readonly Element: string = `${DiscountTag.prefix}-${ElementTypes.Custom}-element`;
  static readonly Price: string = `${DiscountTag.prefix}-${ElementTypes.Span}-price`;
}
